import { css } from '@eti/styles';
import { Inline, Stack, Text } from '@etg/wings';

const numberBallStyles = css`
  background-color: #737373;
  border-radius: 50%;
  color: #fff;
  font-size: 0.75rem;
  height: 20px;
  line-height: 20px;
  text-align: center;
  width: 20px;
`;
const stepTextStyles = css`
  flex: 1;
`;

interface NumberedStep {
  text: string;
  isHtml?: boolean;
}

interface NumberedStepsProps {
  steps: NumberedStep[];
  dataTestId: string;
}

const NumberedSteps = ({ steps, dataTestId }: NumberedStepsProps) => {
  return (
    <Stack role="list" spacing={8}>
      {steps.map((step, index) => (
        <Inline
          alignY="top"
          data-testid={`${dataTestId}-step-${index + 1}`}
          key={`step-${index}`}
          noWrap
          role="listitem"
          spacing={8}
        >
          <div aria-hidden="true" className={numberBallStyles}>
            {index + 1}
          </div>
          <Text asHtml={step.isHtml} className={stepTextStyles}>
            {step.text}
          </Text>
        </Inline>
      ))}
    </Stack>
  );
};

export default NumberedSteps;
